import React from "react";
import { useTranslation } from "next-i18next";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Banners } from "./Banners";
import { useBanner } from "./useBanner";
import { useRouter } from "next/router";
import { utilityLinks } from "../../../../../data/contact-info";
SwiperCore.use([Navigation, Pagination, Autoplay]);

const bulletStyles = {
	"--swiper-pagination-color": "#FFFFFF",
	"--swiper-pagination-bullet-inactive-color": "#FFFFFF",
	"--swiper-pagination-bullet-inactive-opacity": "0.5",
	"--swiper-pagination-bullet-horizontal-gap": "8px",
};

function Banner() {
	const { state } = useBanner();
	const { t } = useTranslation();
	const router = useRouter();

	const properties = [
		{
			id: 1,
			titleLines: [
				[
					{
						highlighted: false,
						text: t("banner.banner-1-title-1"),
					},
				],
				[
					{
						highlighted: false,
						text: t("banner.banner-1-title-2"),
					},
					{
						highlighted: true,
						text: t("banner.banner-1-title-3"),
					},
				],
			],
			color: "#9FE870",
			text: t("banner.banner-1-description"),
			buttonText: t("banner.banner-1-button"),
			href: `/${router.query.locale}/#contact-us`,
			backgroundImg: state.isMobile
				? "/landings/assets/images/banner-1-mobile.png"
				: "/landings/assets/images/banner-1.png",
		},
		{
			id: 2,
			titleLines: [
				[
					{
						highlighted: true,
						text: t("banner.banner-2-title-1"),
					},
				],
				[
					{
						highlighted: false,
						text: t("banner.banner-2-title-2"),
					},
				],
			],
			color: "#CBFA05",
			text: t("banner.banner-2-description"),
			buttonText: t("banner.banner-2-button"),
			href: utilityLinks.workWithUs,
			backgroundImg: state.isMobile
				? "/landings/assets/images/banner-4-mobile.png"
				: "/landings/assets/images/banner-4.png",
		},
		{
			id: 3,
			titleLines: [
				[
					{
						highlighted: false,
						text: t("banner.banner-3-title-1"),
					},
					{
						highlighted: true,
						text: t("banner.banner-3-title-2"),
					},
				],
				[
					{
						highlighted: true,
						text: t("banner.banner-3-title-3"),
					},
					{
						highlighted: true,
						text: t("banner.banner-3-title-4"),
					},
				],
			],
			color: "#7D72FF",
			text: t("banner.banner-3-description"),
			buttonText: t("banner.banner-3-button"),
			href: `/${router.query.locale}/#who-we-are`,
			backgroundImg: state.isMobile
				? "/landings/assets/images/banner-3-mobile.png"
				: "/landings/assets/images/banner-3.png",
		},
	];

	return (
		<Swiper
			height={state.isMobile ? "100vh" : "100%"}
			modules={[Pagination, Autoplay]}
			slidesPerView={1}
			noSwipingSelector="button"
			loop
			pagination={{ type: "bullets", clickable: true }}
			autoplay={{ delay: 10000 }}
			style={{ ...bulletStyles, maxHeight: "100vh" }}
		>
			{properties?.map((slide) => (
				<SwiperSlide key={slide.id}>
					<div className="background-slideshow-container">
						<Banners slide={slide} properties={properties} {...state} />
					</div>
				</SwiperSlide>
			))}
		</Swiper>
	);
}

export default Banner;
